import { type FC } from 'react'

import { useTranslation } from 'react-i18next'

import { addToast } from 'components/Toast/Toast'
import FriendRequest from 'components/UI/NotificationToast/components/FriendRequest'
import { handleFriendRequest } from 'services/endpoints/friendship'

const FriendRequestNotification: FC<{
    data: any
}> = ({ data }) => {
    const { t } = useTranslation()

    if (data?.friendship_status === 0 || data?.isToast) {
        // pending
        return (
            <FriendRequest
                text={t('notifications:hasSentYouAFriendRequest')}
                onAcceptCb={async () => {
                    try {
                        await handleFriendRequest(data?.sender?.id, true)
                    } catch (error) {
                        addToast('error', t('error:acceptingFriendRequest'))
                    }
                }}
                onDeclineCb={async () => {
                    try {
                        await handleFriendRequest(data?.sender?.id, false)
                    } catch (error) {
                        addToast('error', t('error:rejectingFriendRequest'))
                    }
                }}
            />
        )
    } else if (data?.friendship_status === 1) {
        // accepted
        return (
            <div className='friendRequest'>
                <div className='friendRequest__text'>
                    {t('notifications:hasSentYouAFriendRequest')}
                    <br />
                    {t('notifications:friendRequestWasAccepted')}
                </div>
            </div>
        )
    } else if (data?.friendship_status === 2 || data?.friendship_status === 3) {
        // denied or blocked
        return (
            <div className='friendRequest'>
                <div className='friendRequest__text'>
                    {t('notifications:hasSentYouAFriendRequest')}
                    <br />
                    {t('notifications:friendRequestWasDenied')}
                </div>
            </div>
        )
    } else {
        return (
            <div className='friendRequest'>
                <div className='friendRequest__text'>
                    {t('notifications:hasSentYouAFriendRequest')}
                </div>
            </div>
        )
    }
}

export default FriendRequestNotification
